// preview 專用：電子資源正規化資料（Phase 0）。來源 codebase_sa/projects/afats/data/電子資源/。
// 每庫 items 為 preview 取樣（上限 120 筆）；total 為實際筆數。正式版改由後端端點供給。
// udn/Emerald 先只放資料庫層（vendor 連結），品項清單待補。

export const ERESOURCES = [
  {
    "key": "sciencedirect",
    "name": "ScienceDirect 西文電子書",
    "type": "電子書",
    "vendor": "https://www.sciencedirect.com/",
    "trial": false,
    "total": 962,
    "items": [
      {
        "title": "Aircraft Sustainment and Repair",
        "author": "Jones, Rhys",
        "year": "2018",
        "note": "Butterworth-Heinemann",
        "url": "https://www.sciencedirect.com/science/book/9780081005408"
      },
      {
        "title": "Morphing Wing Technologies",
        "author": "Concilio, Antonio",
        "year": "2018",
        "note": "Butterworth-Heinemann",
        "url": "https://www.sciencedirect.com/science/book/9780081009642"
      },
      {
        "title": "Space Safety and Human Performance",
        "author": "Kanki, BarbaraKanki, Barbara",
        "year": "2018",
        "note": "Butterworth-Heinemann",
        "url": "https://www.sciencedirect.com/science/book/9780081018699"
      },
      {
        "title": "Tethered Space Robot",
        "author": "Huang, Panfeng",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128123096"
      },
      {
        "title": "Plasma Engineering",
        "author": "Keidar, Michael",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128137024"
      },
      {
        "title": "Analytical Solutions for Extremal Space Trajectories",
        "author": "Azimov, Dilmurat",
        "year": "2018",
        "note": "Butterworth-Heinemann",
        "url": "https://www.sciencedirect.com/science/book/9780128140581"
      },
      {
        "title": "Modern Flexible Multi-Body Dynamics Modeling Methodology for Flapping Wing Vehicles",
        "author": "Altenbuchner, Cornelia",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128141366"
      },
      {
        "title": "Introduction to Optimum Design",
        "author": "Arora, Jasbir",
        "year": "2017",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128008065"
      },
      {
        "title": "Civil Aircraft Electrical Power System Safety Assessment",
        "author": "Peng, Wang",
        "year": "2017",
        "note": "Butterworth-Heinemann",
        "url": "https://www.sciencedirect.com/science/book/9780081007211"
      },
      {
        "title": "Topology Design Methods for Structural Optimization",
        "author": "Querin, Osvaldo",
        "year": "2017",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780081009161"
      },
      {
        "title": "Nonlinear Optimization of Vehicle Safety Structures",
        "author": "Christensen, Jesper",
        "year": "2016",
        "note": "Butterworth-Heinemann",
        "url": "https://www.sciencedirect.com/science/book/9780128044247"
      },
      {
        "title": "Structural Health Monitoring of Aerospace Composites",
        "author": "Giurgiutiu, Victor",
        "year": "2015",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780124096059"
      },
      {
        "title": "General Aviation Aircraft Design",
        "author": "Gudmundsson, Snorri",
        "year": "2014",
        "note": "Butterworth-Heinemann",
        "url": "https://www.sciencedirect.com/science/book/9780123973085"
      },
      {
        "title": "Reliability Analysis of Dynamic Systems",
        "author": "Wu, Bin",
        "year": "2014",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780124077119"
      },
      {
        "title": "Flight Dynamics Principles",
        "author": "Cook, Michael",
        "year": "2013",
        "note": "Butterworth-Heinemann",
        "url": "https://www.sciencedirect.com/science/book/9780080982427"
      },
      {
        "title": "Biodiversity and Climate Change Adaptation in Tropical Islands",
        "author": "Sivaperuman, Chandrakasan",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128130643"
      },
      {
        "title": "Machine Learning Techniques for Space Weather",
        "author": "Camporeale, Enrico",
        "year": "2018",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780128117880"
      },
      {
        "title": "Handbook of Material Weathering",
        "author": "Wypych, George",
        "year": "2018",
        "note": "ChemTec Publishing",
        "url": "https://www.sciencedirect.com/science/book/9781927885314"
      },
      {
        "title": "Soil Management and Climate Change",
        "author": "Munoz, Maria",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128121283"
      },
      {
        "title": "Understanding Climate Change Impacts on Crop Productivity and Water Balance",
        "author": "Jalota, S.",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128095201"
      },
      {
        "title": "Adapting to Climate Change in Europe",
        "author": "Sanderson, Hans",
        "year": "2018",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780128498873"
      },
      {
        "title": "Macroeconomics of Climate Change in a Dualistic Economy",
        "author": "Acar, Sevil",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128135198"
      },
      {
        "title": "Transforming Climate Finance and Green Investment with Blockchains",
        "author": "Marke, Alastair",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128144473"
      },
      {
        "title": "Service Life Prediction of Polymers and Plastics Exposed to Outdoor Weathering",
        "author": "C White, ChristopherC White, Christopher",
        "year": "2018",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780323497763"
      },
      {
        "title": "Psychology and Climate Change",
        "author": "Clayton, Susan",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128131305"
      },
      {
        "title": "The Behavioral Economics of Climate Change",
        "author": "Seo, S. Niggol",
        "year": "2017",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128118740"
      },
      {
        "title": "Weather Analysis and Forecasting",
        "author": "Santurette, Patrick",
        "year": "2016",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128001943"
      },
      {
        "title": "Demystifying Numerical Models",
        "author": "Mo, John",
        "year": "2019",
        "note": "Butterworth-Heinemann",
        "url": "https://www.sciencedirect.com/science/book/9780081009758"
      },
      {
        "title": "Finite Element Analysis Applications",
        "author": "Bi, Zhuming",
        "year": "2019",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128099520"
      },
      {
        "title": "Connectomics",
        "author": "Wu, Guorong",
        "year": "2019",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128138380"
      },
      {
        "title": "Everyday Applied Geophysics 1",
        "author": "Florsch, Nicolas",
        "year": "2018",
        "note": "ISTE Press - Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9781785481994"
      },
      {
        "title": "Control of Power Electronic Converters and Systems",
        "author": "Blaabjerg, Frede",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128052457"
      },
      {
        "title": "The Circuit Designer's Companion",
        "author": "Wilson, Peter",
        "year": "2018",
        "note": "Newnes",
        "url": "https://www.sciencedirect.com/science/book/9780081017647"
      },
      {
        "title": "Analog Design and Simulation Using OrCAD Capture and PSpice",
        "author": "Fitzpatrick, Dennis",
        "year": "2018",
        "note": "Newnes",
        "url": "https://www.sciencedirect.com/science/book/9780081025055"
      },
      {
        "title": "Oil Spill Environmental Forensics Case Studies",
        "author": "Stout, Scott",
        "year": "2018",
        "note": "Butterworth-Heinemann",
        "url": "https://www.sciencedirect.com/science/book/9780128044346"
      },
      {
        "title": "Matrix Methods for Advanced Structural Analysis",
        "author": "Sapountzakis, Evangelos",
        "year": "2018",
        "note": "Butterworth-Heinemann",
        "url": "https://www.sciencedirect.com/science/book/9780128117088"
      },
      {
        "title": "Biomedical Texture Analysis",
        "author": "Depeursinge, Adrien",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128121337"
      },
      {
        "title": "Cellular Internet of Things",
        "author": "Liberg, Olof",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128124581"
      },
      {
        "title": "Low Cost Wastewater Bioremediation Technology",
        "author": "Bhattacharyaa, Jayanta",
        "year": "2018",
        "note": "Butterworth-Heinemann",
        "url": "https://www.sciencedirect.com/science/book/9780128125106"
      },
      {
        "title": "Modelling, Dynamics and Control of Electrified Vehicles",
        "author": "Du, Haiping",
        "year": "2018",
        "note": "Woodhead Publishing",
        "url": "https://www.sciencedirect.com/science/book/9780128127865"
      },
      {
        "title": "Safety Theory and Control Technology of High-Speed Train Operation",
        "author": "Wang, Junfeng",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128133040"
      },
      {
        "title": "Drag Reduction of Complex Mixtures",
        "author": "Watanabe, Keizo",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128099209"
      },
      {
        "title": "Energy Efficiency in Air Transportation",
        "author": "Benito, Arturo",
        "year": "2018",
        "note": "Butterworth-Heinemann",
        "url": "https://www.sciencedirect.com/science/book/9780128125816"
      },
      {
        "title": "5G Networks",
        "author": "Larsson, Christofer",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128127070"
      },
      {
        "title": "Hybrid Machining",
        "author": "Luo, Xichun",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128130599"
      },
      {
        "title": "Computational Intelligence for Multimedia Big Data on the Cloud with Engineering Applications",
        "author": "Sangaiah, Arun Kumar",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128133149"
      },
      {
        "title": "Computer Vision for Assistive Healthcare",
        "author": "Marco, Leo",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128134450"
      },
      {
        "title": "Cooperative and Graph Signal Processing",
        "author": "Djuric, Petar",
        "year": "2018",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128136775"
      },
      {
        "title": "Sensors for Mechatronics",
        "author": "Regtien, Paul",
        "year": "2018",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780128138106"
      },
      {
        "title": "Radar Propagation and Scattering in a Complex Maritime Environment",
        "author": "Bourlier, Christophe",
        "year": "2018",
        "note": "ISTE Press - Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9781785482304"
      },
      {
        "title": "Smart Sensors and MEMs",
        "author": "Nihtianov, S",
        "year": "2018",
        "note": "Woodhead Publishing",
        "url": "https://www.sciencedirect.com/science/book/9780081020555"
      },
      {
        "title": "Cognitive Information Systems in Management Sciences",
        "author": "Ogiela, Lidia",
        "year": "2017",
        "note": "Morgan Kaufmann",
        "url": "https://www.sciencedirect.com/science/book/9780128038031"
      },
      {
        "title": "Big Data Analytics for Sensor-Network Collected Intelligence",
        "author": "Hsu, Hui-Huang",
        "year": "2017",
        "note": "Morgan Kaufmann",
        "url": "https://www.sciencedirect.com/science/book/9780128093931"
      },
      {
        "title": "Deep Learning for Medical Image Analysis",
        "author": "Zhou, KevinZhou, Kevin",
        "year": "2017",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128104088"
      },
      {
        "title": "Machine Learning",
        "author": "Gori, Marco",
        "year": "2018",
        "note": "Morgan Kaufmann",
        "url": "https://www.sciencedirect.com/science/book/9780081006597"
      },
      {
        "title": "Network Routing",
        "author": "Medhi, Deepankar",
        "year": "2018",
        "note": "Morgan Kaufmann",
        "url": "https://www.sciencedirect.com/science/book/9780128007372"
      },
      {
        "title": "Mobile Cloud Computing",
        "author": "Wu, Huijun",
        "year": "2018",
        "note": "Morgan Kaufmann",
        "url": "https://www.sciencedirect.com/science/book/9780128096413"
      },
      {
        "title": "High Performance Computing",
        "author": "Sterling, Thomas",
        "year": "2018",
        "note": "Morgan Kaufmann",
        "url": "https://www.sciencedirect.com/science/book/9780124201583"
      },
      {
        "title": "Environment Modeling-Based Requirements Engineering for Software Intensive Systems",
        "author": "Jin, Zhi",
        "year": "2018",
        "note": "Morgan Kaufmann",
        "url": "https://www.sciencedirect.com/science/book/9780128019542"
      },
      {
        "title": "Cloud Computing",
        "author": "Marinescu, Dan",
        "year": "2018",
        "note": "Morgan Kaufmann",
        "url": "https://www.sciencedirect.com/science/book/9780128128107"
      },
      {
        "title": "Security in Network Functions Virtualization",
        "author": "Zhang, Zonghua",
        "year": "2018",
        "note": "ISTE Press - Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9781785482571"
      },
      {
        "title": "Building Wireless Sensor Networks",
        "author": "Femmam, Smain",
        "year": "2018",
        "note": "ISTE Press - Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9781785482748"
      },
      {
        "title": "Complex Systems and Clouds",
        "author": "Marinescu, Dan",
        "year": "2017",
        "note": "Morgan Kaufmann",
        "url": "https://www.sciencedirect.com/science/book/9780128040416"
      },
      {
        "title": "Data Hiding Techniques in Windows OS",
        "author": "Hassan, Nihad",
        "year": "2017",
        "note": "Syngress",
        "url": "https://www.sciencedirect.com/science/book/9780128044490"
      },
      {
        "title": "Advances in GPU Research and Practice",
        "author": "Azad, Hamid",
        "year": "2017",
        "note": "Morgan Kaufmann",
        "url": "https://www.sciencedirect.com/science/book/9780128037386"
      },
      {
        "title": "Emerging Paradigms in Urban Mobility",
        "author": "Agarwal, Om Prakash",
        "year": "2019",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780128114346"
      },
      {
        "title": "Green Ports",
        "author": "Bergqvist, Rickard",
        "year": "2019",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780128140543"
      },
      {
        "title": "Transportation Cyber-Physical Systems",
        "author": "Deka, Lipika",
        "year": "2019",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780128142950"
      },
      {
        "title": "Microeconomic Modeling in Urban Science",
        "author": "Concha, Francisco",
        "year": "2019",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128152966"
      },
      {
        "title": "Digital Participation through Social Living Labs",
        "author": "Dezuanni, Michael",
        "year": "2018",
        "note": "Chandos Publishing",
        "url": "https://www.sciencedirect.com/science/book/9780081020593"
      },
      {
        "title": "The Psychology of the Car",
        "author": "Gossling, Stefan",
        "year": "2018",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780128110089"
      },
      {
        "title": "The Future of Chinese Manufacturing",
        "author": "Chin, Corinna",
        "year": "2018",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780081011089"
      },
      {
        "title": "IMPACT Learning",
        "author": "Maybee, Clarence",
        "year": "2018",
        "note": "Chandos Publishing",
        "url": "https://www.sciencedirect.com/science/book/9780081020777"
      },
      {
        "title": "Research Methods",
        "author": "Williamson, Kirsty",
        "year": "2018",
        "note": "Chandos Publishing",
        "url": "https://www.sciencedirect.com/science/book/9780081022207"
      },
      {
        "title": "Air Traffic Management",
        "author": "Arblaster, Margaret",
        "year": "2018",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780128111185"
      },
      {
        "title": "Children’s Active Transportation",
        "author": "Larouche, Richard",
        "year": "2018",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780128119310"
      },
      {
        "title": "Bicycling for Transportation",
        "author": "Bopp, Melissa",
        "year": "2018",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780128126424"
      },
      {
        "title": "Experiencing Climate Change in Bangladesh",
        "author": "Momtaz, Salim",
        "year": "2016",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780128034040"
      },
      {
        "title": "Hydro-Meteorological Hazards Risks and Disasters",
        "author": "Paron, Paolo",
        "year": "2015",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780123948465"
      },
      {
        "title": "Coastal Risk Assessment and Mitigation in a Changing Climate",
        "author": "Zanuttigh, Barbara",
        "year": "2015",
        "note": "Butterworth-Heinemann",
        "url": "https://www.sciencedirect.com/science/book/9780123973108"
      },
      {
        "title": "Mathematical and Physical Fundamentals of Climate Change",
        "author": "Zhang, Zhihua",
        "year": "2015",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780128000663"
      },
      {
        "title": "Climate Change",
        "author": "Letcher, Trevor",
        "year": "2015",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780444635242"
      },
      {
        "title": "The Earth’s Electric Field",
        "author": "Kelley, Michael",
        "year": "2014",
        "note": "Elsevier Science",
        "url": "https://www.sciencedirect.com/science/book/9780123978868"
      },
      {
        "title": "Microclimate for Cultural Heritage",
        "author": "Camuffo, D.",
        "year": "2014",
        "note": "",
        "url": "https://www.sciencedirect.com/science/book/9780444632968"
      },
      {
        "title": "Coastal Disasters and Climate Change in Vietnam",
        "author": "Thao, Nguyen Danh",
        "year": "2014",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780128000076"
      },
      {
        "title": "Optical Radiometry for Ocean Climate Measurements",
        "author": "Zibordi, Giuseppe",
        "year": "2014",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780124170117"
      },
      {
        "title": "Ocean Circulation and Climate",
        "author": "",
        "year": "2013",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780123918512"
      },
      {
        "title": "The Effect of UV Light and Weather on Plastics and Elastomers, 3e",
        "author": "McKeen, Laurence",
        "year": "2013",
        "note": "William Andrew",
        "url": "https://www.sciencedirect.com/science/book/9781455728510"
      },
      {
        "title": "Handbook of Material Weathering",
        "author": "Wypych, George",
        "year": "2013",
        "note": "",
        "url": "https://www.sciencedirect.com/science/book/9781895198621"
      },
      {
        "title": "Climate Change, Air Pollution and Global Challenges",
        "author": "",
        "year": "2013",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780080983493"
      },
      {
        "title": "Managing Ocean Environments in a Changing Climate",
        "author": "Noone, Kevin",
        "year": "2013",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780124076686"
      },
      {
        "title": "The Future of the World's Climate",
        "author": "Henderson-Sellers, Ann",
        "year": "2012",
        "note": "Elsevier Science",
        "url": "https://www.sciencedirect.com/science/book/9780123869173"
      },
      {
        "title": "Highlights in Helioclimatology",
        "author": "Perez-Peraza, Jorge",
        "year": "2012",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780124159778"
      },
      {
        "title": "The Climate of the Mediterranean Region",
        "author": "Lionello, P.",
        "year": "2012",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780124160422"
      },
      {
        "title": "Ostracoda as Proxies for Quaternary Climate Change",
        "author": "",
        "year": "2012",
        "note": "Elsevier Science",
        "url": "https://www.sciencedirect.com/science/book/9780444536365"
      },
      {
        "title": "Evidence-Based Climate Science",
        "author": "Easterbrook, Don",
        "year": "2011",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780123859563"
      },
      {
        "title": "Evolution of Earth and its Climate: Birth, Life and Death of Earth",
        "author": "Sorokhtin, O.G.",
        "year": "2011",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780444537577"
      },
      {
        "title": "Handbook of Stable Isotope Analytical Techniques",
        "author": "de Groot, Pier",
        "year": "2009",
        "note": "Elsevier Science",
        "url": "https://www.sciencedirect.com/science/book/9780444511157"
      },
      {
        "title": "Climate Change",
        "author": "Trevor Letcher",
        "year": "2009",
        "note": "Elsevier Science",
        "url": "https://www.sciencedirect.com/science/book/9780444533012"
      },
      {
        "title": "Textiles for Cold Weather Apparel",
        "author": "Williams, J T",
        "year": "2009",
        "note": "Woodhead Publishing",
        "url": "https://www.sciencedirect.com/science/book/9781845694111"
      },
      {
        "title": "Antarctic Climate Evolution",
        "author": "Fabio Florindo, Martin Siegert",
        "year": "2008",
        "note": "Elsevier Science",
        "url": "https://www.sciencedirect.com/science/book/9780444528476"
      },
      {
        "title": "Climate Change and Cultural Dynamics",
        "author": "David G. Anderson, Kirk Maasch, Daniel H. Sandweiss",
        "year": "2007",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780120883905"
      },
      {
        "title": "Global Climate Change and Response of Carbon Cycle in the Equatorial Pacific and Indian Oceans and Adjacent Landmasses",
        "author": "Hodaka Kawahata, Yoshio Awaya",
        "year": "2007",
        "note": "Elsevier Science",
        "url": "https://www.sciencedirect.com/science/book/9780444529480"
      },
      {
        "title": "The Climate of Past Interglacials",
        "author": "F. Sirocko, M. Claussen, T. Litt, M.F. Sanchez-Goni",
        "year": "2007",
        "note": "Elsevier Science",
        "url": "https://www.sciencedirect.com/science/book/9780444529558"
      },
      {
        "title": "Late Quaternary Climate Change and Human Adaptation in Arid China",
        "author": "D.B. Madsen, F. Chen, X. Gao",
        "year": "2007",
        "note": "Elsevier Science",
        "url": "https://www.sciencedirect.com/science/book/9780444529626"
      },
      {
        "title": "Climate, Environment, and Society in the Pacific during the Last Millennium",
        "author": "Patrick D. Nunn",
        "year": "2007",
        "note": "Elsevier Science",
        "url": "https://www.sciencedirect.com/science/book/9780444528162"
      },
      {
        "title": "Driving Climate Change",
        "author": "Daniel Sperling, James S. Cannon",
        "year": "2007",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780123694959"
      },
      {
        "title": "Mediterranean Climate Variability",
        "author": "P. Lionello, Paola Malanotte-Rizzoli, R. Boscolo",
        "year": "2006",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780444521705"
      },
      {
        "title": "Automotive Air Conditioning and Climate Control Systems",
        "author": "Steven Daly",
        "year": "2006",
        "note": "Butterworth-Heinemann",
        "url": "https://www.sciencedirect.com/science/book/9780750669559"
      },
      {
        "title": "The Effect of UV Light and Weather on Plastics and Elastomers",
        "author": "Liesl K. Massey",
        "year": "2006",
        "note": "WAP",
        "url": "https://www.sciencedirect.com/science/book/9780815515258"
      },
      {
        "title": "Earth as an Evolving Planetary System",
        "author": "Kent C Condie",
        "year": "2005",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780120883929"
      },
      {
        "title": "Carbon Dioxide Capture for Storage in Deep Geologic Formations - Results from the CO² Capture Project",
        "author": "David Thomas, Sally Benson",
        "year": "2005",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780080445700"
      },
      {
        "title": "The Geometrical Tolerancing Desk Reference",
        "author": "Paul Green",
        "year": "2005",
        "note": "Newnes",
        "url": "https://www.sciencedirect.com/science/book/9780750668217"
      },
      {
        "title": "Frontiers in Magnetospheric Plasma Physics",
        "author": "Masahiro Hoshino, Yoshiharu Omura, Louis Lanzerotti",
        "year": "2005",
        "note": "Pergamon",
        "url": "https://www.sciencedirect.com/science/book/9780080445731"
      },
      {
        "title": "The Institutional Economics of MarketBased Climate Policy",
        "author": "E. Woerdman",
        "year": "2004",
        "note": "Elsevier",
        "url": "https://www.sciencedirect.com/science/book/9780444515735"
      },
      {
        "title": "Ice Microdynamics",
        "author": "Pao Wang",
        "year": "2002",
        "note": "Academic Press",
        "url": "https://www.sciencedirect.com/science/book/9780127346038"
      },
      {
        "title": "Handbook of Air Pollution Prevention and Control",
        "author": "Nicholas P Cheremisinoff",
        "year": "2002",
        "note": "Butterworth-Heinemann",
        "url": "https://www.sciencedirect.com/science/book/9780750674997"
      },
      {
        "title": "Space Weather Study Using Multipoint Techniques",
        "author": "L.H. Lyu",
        "year": "2002",
        "note": "Pergamon",
        "url": "https://www.sciencedirect.com/science/book/9780080440576"
      },
      {
        "title": "Multi-Wavelength Observations of Coronal Structure and Dynamics",
        "author": "P. Martens, D. Cauffman",
        "year": "2002",
        "note": "Pergamon",
        "url": "https://www.sciencedirect.com/science/book/9780080440606"
      },
      {
        "title": "Solar-Terrestrial Magnetic Activity and Space Environment",
        "author": "H. Wang",
        "year": "2002",
        "note": "Pergamon",
        "url": "https://www.sciencedirect.com/science/book/9780080441108"
      }
    ]
  },
  {
    "key": "kono",
    "name": "KONO 電子雜誌",
    "type": "電子雜誌",
    "vendor": "https://library.thekono.com/afats/libraries/chinese",
    "trial": false,
    "total": 249,
    "items": [
      {
        "title": "世界民航雜誌Airway",
        "author": "",
        "year": "2024–2025",
        "note": "ISSN 1028-1789",
        "url": ""
      },
      {
        "title": "Megami MAGAZINE（メガミマガジン）",
        "author": "",
        "year": "2024–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "SALT...",
        "author": "",
        "year": "2024–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "pen tw國際中文版",
        "author": "",
        "year": "2024–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "English Digest實用空中美語",
        "author": "",
        "year": "2023–2025",
        "note": "ISSN 1017-804X",
        "url": ""
      },
      {
        "title": "English 4U活用空中美語",
        "author": "",
        "year": "2023–2025",
        "note": "ISSN 1563-2946",
        "url": ""
      },
      {
        "title": "A+ English空中美語",
        "author": "",
        "year": "2023–2025",
        "note": "ISSN 1605-8097",
        "url": ""
      },
      {
        "title": "CLUB HARLEY",
        "author": "",
        "year": "2016–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "Ciao潮旅",
        "author": "",
        "year": "2018–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "住展雜誌",
        "author": "",
        "year": "2023–2025",
        "note": "ISSN 1607-9299",
        "url": ""
      },
      {
        "title": "書評書目",
        "author": "",
        "year": "2023–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "彭博商周焦點",
        "author": "",
        "year": "2023–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "Argument",
        "author": "",
        "year": "2023–2025",
        "note": "ISSN 2825-9319",
        "url": ""
      },
      {
        "title": "GO OUT",
        "author": "",
        "year": "2024–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "野菜だより",
        "author": "",
        "year": "2024–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "Southern Living",
        "author": "",
        "year": "2022–2024",
        "note": "ISSN 0038-4305",
        "url": ""
      },
      {
        "title": "TURNS",
        "author": "",
        "year": "2022–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "LiVES",
        "author": "",
        "year": "2023–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "遠見",
        "author": "",
        "year": "2022–2025",
        "note": "ISSN 1017-5741",
        "url": ""
      },
      {
        "title": "游絲腕表年鑑",
        "author": "",
        "year": "2016–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "游絲腕表",
        "author": "",
        "year": "2013–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "JET",
        "author": "",
        "year": "2013–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "新電子科技雜誌",
        "author": "",
        "year": "2017–2025",
        "note": "ISSN 1022-2928",
        "url": ""
      },
      {
        "title": "La Vie",
        "author": "",
        "year": "2016–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "BBC 知識 Knowledge",
        "author": "",
        "year": "2015–2025",
        "note": "ISSN 2224-655X",
        "url": ""
      },
      {
        "title": "城邦國際名表",
        "author": "",
        "year": "2016–2024",
        "note": "ISSN 1729-4711",
        "url": ""
      },
      {
        "title": "漂亮家居",
        "author": "",
        "year": "2013–2023",
        "note": "",
        "url": ""
      },
      {
        "title": "DIGI PHOTO 數位相機採購活用",
        "author": "",
        "year": "2016–2023",
        "note": "ISSN 1727-5342",
        "url": ""
      },
      {
        "title": "網管人",
        "author": "",
        "year": "2017–2025",
        "note": "ISSN 1990-6498",
        "url": ""
      },
      {
        "title": "新通訊元件雜誌",
        "author": "",
        "year": "2017–2025",
        "note": "ISSN 1608-747x",
        "url": ""
      },
      {
        "title": "TRAVELER Luxe 旅人誌",
        "author": "",
        "year": "2013–2025",
        "note": "ISSN 1998-4537",
        "url": ""
      },
      {
        "title": "PC home 電腦家庭",
        "author": "",
        "year": "2015–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "好吃",
        "author": "",
        "year": "2015–2020",
        "note": "",
        "url": ""
      },
      {
        "title": "戶外探索 Outside",
        "author": "",
        "year": "2021–2023",
        "note": "ISSN 2227-5177",
        "url": ""
      },
      {
        "title": "單車誌",
        "author": "",
        "year": "2021–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "GetNavi",
        "author": "",
        "year": "2021–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "SquareRooms",
        "author": "",
        "year": "2021–2024",
        "note": "ISSN 0219-4570",
        "url": ""
      },
      {
        "title": "Oriental Cuisine 美味风采",
        "author": "",
        "year": "2022–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "Feminine 风采",
        "author": "",
        "year": "2022–2024",
        "note": "ISSN 0128-911X",
        "url": ""
      },
      {
        "title": "Citta Bella 都会佳人",
        "author": "",
        "year": "2022–2024",
        "note": "ISSN 1394-9519",
        "url": ""
      },
      {
        "title": "Art Republik Vietnam",
        "author": "",
        "year": "2020–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "World of Watches Vietnam",
        "author": "",
        "year": "2021–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "Yacht Style Vietnam",
        "author": "",
        "year": "2021–2023",
        "note": "",
        "url": ""
      },
      {
        "title": "Men's Folio Vietnam",
        "author": "",
        "year": "2021–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "L'Officiel Vietnam",
        "author": "",
        "year": "2021–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "Hi Fi 聖經",
        "author": "",
        "year": "2022–2024",
        "note": "ISSN 2790-1599",
        "url": ""
      },
      {
        "title": "美しいキモノ",
        "author": "",
        "year": "2024–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "婦人画報",
        "author": "",
        "year": "2024–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "Richesse リシェス",
        "author": "",
        "year": "2024–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "MODERN LIVING　モダンリビング",
        "author": "",
        "year": "2024–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "MEN’S CLUB",
        "author": "",
        "year": "2024–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "Harper's Bazaar ハーパーズ バザー",
        "author": "",
        "year": "2024–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "ELLE JAPON エル ジャポン",
        "author": "",
        "year": "2024–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "ELLE gourmet エル・グルメ",
        "author": "",
        "year": "2024–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "ELLE DECOR",
        "author": "",
        "year": "2024–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "25ans Wedding",
        "author": "",
        "year": "2024–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "25ans",
        "author": "",
        "year": "2024–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "早安健康",
        "author": "",
        "year": "2021–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "Davison",
        "author": "",
        "year": "2021–2023",
        "note": "",
        "url": ""
      },
      {
        "title": "Portfolio",
        "author": "",
        "year": "2021–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "d+a: Design and Architecture",
        "author": "",
        "year": "2021–2024",
        "note": "ISSN 0219-5143",
        "url": ""
      },
      {
        "title": "Solitaire",
        "author": "",
        "year": "2021–2024",
        "note": "ISSN 0219-7138",
        "url": ""
      },
      {
        "title": "epicure",
        "author": "",
        "year": "2021–2024",
        "note": "ISSN 2010-1155",
        "url": ""
      },
      {
        "title": "Jetgala",
        "author": "",
        "year": "2021–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "Golf Asia",
        "author": "",
        "year": "2021–2025",
        "note": "ISSN 0219-0605",
        "url": ""
      },
      {
        "title": "GT-R Magazine",
        "author": "",
        "year": "2024–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "韓流ぴあ",
        "author": "",
        "year": "2024–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "ゆるふわ愛されヘア",
        "author": "",
        "year": "2021–2023",
        "note": "",
        "url": ""
      },
      {
        "title": "大人の愛されヘアカタログ",
        "author": "",
        "year": "2015–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "北欧テイストの部屋づくり",
        "author": "",
        "year": "2015–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "ゆるふわショート＆ボブ",
        "author": "",
        "year": "2015–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "ねこ",
        "author": "",
        "year": "2012–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "キレイな大人ヘア",
        "author": "",
        "year": "2015–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "CAR MAGAZINE カーマガジン",
        "author": "",
        "year": "2016–2019",
        "note": "",
        "url": ""
      },
      {
        "title": "AUTOCAMPER",
        "author": "",
        "year": "2019–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "サイクルスポーツ",
        "author": "",
        "year": "2017–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "週刊プロレス",
        "author": "",
        "year": "2024–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "週刊ベースボール",
        "author": "",
        "year": "2017–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "WAGONIST",
        "author": "",
        "year": "2022–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "CARトップ",
        "author": "",
        "year": "2024–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "RETRIEVER",
        "author": "",
        "year": "2016–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "HAWAII STYLE ハワイスタイル",
        "author": "",
        "year": "2016–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "趣味の文具箱",
        "author": "",
        "year": "2016–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "PREPPY",
        "author": "",
        "year": "2016–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "Men’s PREPPY",
        "author": "",
        "year": "2016–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "Lightning",
        "author": "",
        "year": "2016–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "CLUTCH Magazine",
        "author": "",
        "year": "2016–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "2nd",
        "author": "",
        "year": "2016–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "週刊エコノミスト",
        "author": "",
        "year": "2021–2025",
        "note": "ISSN 0422-8359",
        "url": ""
      },
      {
        "title": "アニメディア",
        "author": "",
        "year": "2024–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "PRESTIGE品雜誌 國際中文版",
        "author": "",
        "year": "2021–2025",
        "note": "",
        "url": ""
      },
      {
        "title": "理財周刊特刊",
        "author": "",
        "year": "2021–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "Magazine P雜誌",
        "author": "",
        "year": "2020–2022",
        "note": "ISSN 2414-3065",
        "url": ""
      },
      {
        "title": "Plaza magazine (Skandinavien Edition)",
        "author": "",
        "year": "2017–2024",
        "note": "ISSN 1400-3961",
        "url": ""
      },
      {
        "title": "Hong Kong Dance Magazine",
        "author": "",
        "year": "2021–2022",
        "note": "",
        "url": ""
      },
      {
        "title": "號外 City Magazine",
        "author": "",
        "year": "2021–2025",
        "note": "ISSN 1024-1205",
        "url": ""
      },
      {
        "title": "常春月刊",
        "author": "",
        "year": "2020–2025",
        "note": "ISSN 1017-7876",
        "url": ""
      },
      {
        "title": "Sample樣本",
        "author": "",
        "year": "2020–2022",
        "note": "ISSN 2415-4385",
        "url": ""
      },
      {
        "title": "放假啦！",
        "author": "",
        "year": "2020–2021",
        "note": "",
        "url": ""
      },
      {
        "title": "dpi設計插畫誌",
        "author": "",
        "year": "2020–2024",
        "note": "ISSN 2519-6758",
        "url": ""
      },
      {
        "title": "康健雜誌特刊",
        "author": "",
        "year": "2017–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "摩登家庭 Modern Home",
        "author": "",
        "year": "2020–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "彭博商業周刊/中文版",
        "author": "",
        "year": "2020–2025",
        "note": "ISSN 2308-507X",
        "url": ""
      },
      {
        "title": "UNA",
        "author": "",
        "year": "2019–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "MR STYLE",
        "author": "",
        "year": "2020–2024",
        "note": "ISSN 19975074",
        "url": ""
      },
      {
        "title": "MRRM",
        "author": "",
        "year": "2020–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "Arena Homme+",
        "author": "",
        "year": "2020–2024",
        "note": "ISSN 2005-9507",
        "url": ""
      },
      {
        "title": "enya FASHION QUEEN",
        "author": "",
        "year": "2019–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "財訊趨勢贏家",
        "author": "",
        "year": "2020–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "財訊雙週刊",
        "author": "",
        "year": "2020–2024",
        "note": "ISSN 2078-952-1",
        "url": ""
      },
      {
        "title": "Smart智富月刊精選",
        "author": "",
        "year": "2020–2025",
        "note": "ISSN 1561-4654",
        "url": ""
      },
      {
        "title": "商業周刊精選",
        "author": "",
        "year": "2020–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "康軒學習雜誌初階版",
        "author": "",
        "year": "2019–2024",
        "note": "ISSN 1726-9369",
        "url": ""
      },
      {
        "title": "康軒學習雜誌進階版",
        "author": "",
        "year": "2019–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "字花",
        "author": "",
        "year": "2018–2024",
        "note": "ISSN 1819-9178",
        "url": ""
      },
      {
        "title": "英語島雜誌",
        "author": "",
        "year": "2018–2021",
        "note": "ISSN 2310-5208",
        "url": ""
      },
      {
        "title": "REALSIMPLE",
        "author": "",
        "year": "2020–2024",
        "note": "ISSN 1528-1701",
        "url": ""
      },
      {
        "title": "Living Sense",
        "author": "",
        "year": "2020–2020",
        "note": "ISSN 1228-3355",
        "url": ""
      },
      {
        "title": "id SHOW\" 住宅影音誌\"",
        "author": "",
        "year": "2019–2024",
        "note": "",
        "url": ""
      },
      {
        "title": "People",
        "author": "",
        "year": "2020–2024",
        "note": "ISSN 0093-7673",
        "url": ""
      }
    ]
  },
  {
    "key": "ddc",
    "name": "DDC 國際博碩士論文",
    "type": "學位論文",
    "vendor": "https://pqdd.sinica.edu.tw/",
    "trial": false,
    "total": 3325,
    "items": [
      {
        "title": "Prediction of transition for attached and separated shear layers in turbomachinery",
        "author": "Langtry, Robin Blair",
        "year": "2003",
        "note": "Carleton University (Canada)",
        "url": ""
      },
      {
        "title": "A numerical and analytical study of detonation diffraction",
        "author": "Arienti, Marco",
        "year": "2003",
        "note": "California Institute of Technology",
        "url": ""
      },
      {
        "title": "Receptivity of compressible mixing layers",
        "author": "Barone, Matthew Franklin",
        "year": "2003",
        "note": "Stanford University",
        "url": ""
      },
      {
        "title": "Transformation of linear control algorithms into operationally optimal real -time tasks",
        "author": "Bhattacharya, Raktim",
        "year": "2003",
        "note": "University of Minnesota",
        "url": ""
      },
      {
        "title": "A Karhunen-Loève least -squares technique for optimization of geometry of a blunt body in supersonic flow",
        "author": "Brooks, Gregory Phillip",
        "year": "2003",
        "note": "University of Notre Dame",
        "url": ""
      },
      {
        "title": "A multifractal subgrid-scale model for the large -eddy simulation of turbulent flows",
        "author": "Burton, Gregory Charles",
        "year": "2003",
        "note": "University of Michigan",
        "url": ""
      },
      {
        "title": "Precise formation-state estimation in low Earth orbit using carrier differential GPS",
        "author": "Busse, Franz Dewey",
        "year": "2003",
        "note": "Stanford University",
        "url": ""
      },
      {
        "title": "Recombination processes in a flowing magnetized plasma: Application to ionization energy recovery in the variable specific impulse magnetoplasma rocket (VASIMR)",
        "author": "Chavers, Donald Gregory",
        "year": "2003",
        "note": "The University of Alabama in Huntsville",
        "url": ""
      },
      {
        "title": "Three-dimensional acceleration planning for atmospheric entry",
        "author": "Chen, David Teh-Han",
        "year": "2003",
        "note": "University of California, Irvine",
        "url": ""
      },
      {
        "title": "Detection and orbit determination of tethered satellite systems",
        "author": "Choe, Nammi Jo",
        "year": "2003",
        "note": "Auburn University",
        "url": ""
      },
      {
        "title": "Dynamics of randomly perturbed nonlinear structural and mechanical systems with resonances",
        "author": "Choi, Seunggil",
        "year": "2003",
        "note": "University of Illinois at Urbana-Champaign",
        "url": ""
      },
      {
        "title": "On flow topology changes accompanying aerodynamic bifurcation for aircraft with vented strakes",
        "author": "Cook, Stephen Price",
        "year": "2003",
        "note": "University of Maryland, College Park",
        "url": ""
      },
      {
        "title": "Modelling of ceramic matrix composite microstructure using a two-dimensional fractal spatial particle distribution",
        "author": "Cottet, Arnaud J.",
        "year": "2003",
        "note": "Georgia Institute of Technology",
        "url": ""
      },
      {
        "title": "An application of anti -optimization in the process of validating aerodynamic codes",
        "author": "Cruz, Juan R.",
        "year": "2003",
        "note": "Virginia Polytechnic Institute and State University",
        "url": ""
      },
      {
        "title": "Parallel implicit algorithms for direct numerical simulations of hypersonic boundary layer stability and transition",
        "author": "Dong, Haibo",
        "year": "2003",
        "note": "University of California, Los Angeles",
        "url": ""
      },
      {
        "title": "System identification of nonlinear resonant systems",
        "author": "Dunstan, Wayne John",
        "year": "2003",
        "note": "University of California, San Diego",
        "url": ""
      },
      {
        "title": "Study of turbulent burning velocity using laser diagnostics in turbulent premixed flames",
        "author": "Filatyev, Sergei Aleksandrovich",
        "year": "2003",
        "note": "University of Michigan",
        "url": ""
      },
      {
        "title": "A new theory for symmetric laminated plates",
        "author": "Guiamatsia Tafeuvoukeng, Irene",
        "year": "2003",
        "note": "University of Toronto (Canada)",
        "url": ""
      },
      {
        "title": "A variational technique for spacecraft trajectory planning",
        "author": "Henshaw, Carl Glen",
        "year": "2003",
        "note": "University of Maryland, College Park",
        "url": ""
      },
      {
        "title": "Prediction models for validating development phase cost estimates for missile development programs",
        "author": "Hughes, William Evans, Jr.",
        "year": "2003",
        "note": "The University of Alabama in Huntsville",
        "url": ""
      },
      {
        "title": "Recovery in fault -tolerant distributed microcontrollers",
        "author": "Hwang, Riki I-Ming",
        "year": "2003",
        "note": "University of California, Los Angeles",
        "url": ""
      },
      {
        "title": "Toward real-time en route air traffic control optimization",
        "author": "Jardin, Matthew Robert",
        "year": "2003",
        "note": "Stanford University",
        "url": ""
      },
      {
        "title": "Threat displays for final approach",
        "author": "Jennings, Chad Warren",
        "year": "2003",
        "note": "Stanford University",
        "url": ""
      },
      {
        "title": "An object -based interaction framework for the operation of multiple field robots",
        "author": "Jones, Henry Lee, II",
        "year": "2003",
        "note": "Stanford University",
        "url": ""
      },
      {
        "title": "The simulation of flexible aircraft",
        "author": "Karkas, George",
        "year": "2003",
        "note": "University of Toronto (Canada)",
        "url": ""
      },
      {
        "title": "Fresnel zone and reflectarray antennas for space missions: Concepts, computational techniques and characterizations",
        "author": "Khayatian, Behrouz",
        "year": "2003",
        "note": "University of California, Los Angeles",
        "url": ""
      },
      {
        "title": "The multidisciplinary design optimization of a distributed propulsion blended -wing -body aircraft",
        "author": "Ko, Yan-Yee Andy",
        "year": "2003",
        "note": "Virginia Polytechnic Institute and State University",
        "url": ""
      },
      {
        "title": "An experimental investigation of Richtmyer -Meshkov instability",
        "author": "Kumar, Sanjay",
        "year": "2003",
        "note": "California Institute of Technology",
        "url": ""
      },
      {
        "title": "A Navier -Stokes equation solver using agglomerated multigrid featuring directional coarsening and line -implicit smoothing",
        "author": "Lassaline, Jason Vern",
        "year": "2003",
        "note": "University of Toronto (Canada)",
        "url": ""
      },
      {
        "title": "Numerical simulations of the aerodynamic characteristics of circulation control wing sections",
        "author": "Liu, Yi",
        "year": "2003",
        "note": "Georgia Institute of Technology",
        "url": ""
      },
      {
        "title": "Extending the functionalities of Cartesian grid solvers: Viscous effects modeling and MPI parallelization",
        "author": "Marshall, David D.",
        "year": "2003",
        "note": "Georgia Institute of Technology",
        "url": ""
      },
      {
        "title": "A coupled -adjoint method for high-fidelity aero -structural optimization",
        "author": "Martins, Joaquim Rafael Rost A.",
        "year": "2003",
        "note": "Stanford University",
        "url": ""
      },
      {
        "title": "High Reynolds number turbulent pipe flow",
        "author": "McKeon, Beverley J.",
        "year": "2003",
        "note": "Princeton University",
        "url": ""
      },
      {
        "title": "The application of non -linear frequency domain methods to the Euler and Navier -Stokes equations",
        "author": "McMullen, Matthew Scott",
        "year": "2003",
        "note": "Stanford University",
        "url": ""
      },
      {
        "title": "An experimental investigation of unsteady surface pressure on single and multiple airfoils",
        "author": "Mish, Patrick Francis",
        "year": "2003",
        "note": "Virginia Polytechnic Institute and State University",
        "url": ""
      },
      {
        "title": "Predictive thermal analysis of the combat sentinel satellite test article",
        "author": "Moffitt, Blake Almy",
        "year": "2003",
        "note": "Utah State University",
        "url": ""
      },
      {
        "title": "Heterogeneous flame propagation and flammability limits",
        "author": "Moon, InSang",
        "year": "2003",
        "note": "University of Michigan",
        "url": ""
      },
      {
        "title": "Optimal shape design of aerodynamic configurations: A Newton -Krylov approach",
        "author": "Nemec, Marian",
        "year": "2003",
        "note": "University of Toronto (Canada)",
        "url": ""
      },
      {
        "title": "Investigation of reversal phenomena in forebody vortex manipulation by forward facing nozzles",
        "author": "Neuteboom, Martin Oliver",
        "year": "2003",
        "note": "Carleton University (Canada)",
        "url": ""
      },
      {
        "title": "Layered heat flux gauges for aeroentry application",
        "author": "Oishi, Tomomi",
        "year": "2003",
        "note": "The University of Arizona",
        "url": ""
      },
      {
        "title": "Slat tonal noise mechanisms in a two -dimensional multi-element airfoil configuration",
        "author": "Olson, Susan Denise",
        "year": "2003",
        "note": "University of Notre Dame",
        "url": ""
      },
      {
        "title": "Investigation of the iced flowfield characteristics related to the stall margin instrumentation used in icing conditions",
        "author": "Pederson, Erik Thomas",
        "year": "2003",
        "note": "Western Michigan University",
        "url": ""
      },
      {
        "title": "Static and dynamic analysis of a typical wing section with leading edge-trailing edge control surface configuration",
        "author": "Platanitis, George",
        "year": "2003",
        "note": "Texas A&M University",
        "url": ""
      },
      {
        "title": "Advanced optimal design concepts for composite material aircraft repair",
        "author": "Renaud, Guillaume",
        "year": "2003",
        "note": "University of Toronto (Canada)",
        "url": ""
      },
      {
        "title": "Managing simulation -based training: A framework for optimizing learning, cost, and time",
        "author": "Richmond, Noah Joseph",
        "year": "2003",
        "note": "Stanford University",
        "url": ""
      },
      {
        "title": "Trailing edge noise propagation through a cascade of blades",
        "author": "Roy, Charlie Desire",
        "year": "2003",
        "note": "Florida Atlantic University",
        "url": ""
      },
      {
        "title": "Modeling of plasma propulsion using an inflated magnetic field and its interaction with a fast plasma stream",
        "author": "Saha, Saikat",
        "year": "2003",
        "note": "The University of Alabama in Huntsville",
        "url": ""
      },
      {
        "title": "Ranging error overbounds for navigation integrity of local area augmented GPS",
        "author": "Sayim, Irfan",
        "year": "2003",
        "note": "Illinois Institute of Technology",
        "url": ""
      },
      {
        "title": "Improving target orientation discrimination performance in air -to -air flight simulation",
        "author": "Serfoss, Gary Lee",
        "year": "2003",
        "note": "Arizona State University",
        "url": ""
      },
      {
        "title": "Optimal scheduling for satellite refuelling in circular orbits",
        "author": "Shen, Haijun",
        "year": "2003",
        "note": "Georgia Institute of Technology",
        "url": ""
      },
      {
        "title": "Spatio-temporal dynamics of periodically forced rotating flows",
        "author": "Sinha, Manish",
        "year": "2003",
        "note": "Princeton University",
        "url": ""
      },
      {
        "title": "Spread spectrum time domain reflectometry",
        "author": "Smith, Paul Samuel",
        "year": "2003",
        "note": "Utah State University",
        "url": ""
      },
      {
        "title": "Deconvolution of ion velocity distributions from laser -induced fluorescence spectra of xenon electrostatic thruster plumes",
        "author": "Smith, Timothy B.",
        "year": "2003",
        "note": "University of Michigan",
        "url": ""
      },
      {
        "title": "Technique for the optimization of the powerhead configuration and performance of liquid rocket engines",
        "author": "St. Germain, Brad David",
        "year": "2003",
        "note": "Georgia Institute of Technology",
        "url": ""
      },
      {
        "title": "Large -eddy simulation of combustion dynamics in swirling flows",
        "author": "Stone, Christopher Pritchard",
        "year": "2003",
        "note": "Georgia Institute of Technology",
        "url": ""
      },
      {
        "title": "Information preservation methods for modeling micro-scale gas flows",
        "author": "Sun, Quanhua",
        "year": "2003",
        "note": "University of Michigan",
        "url": ""
      },
      {
        "title": "Variational Arbitrary Lagrangian -Eulerian method",
        "author": "Thoutireddy, Pururav",
        "year": "2003",
        "note": "California Institute of Technology",
        "url": ""
      },
      {
        "title": "Development of an experimental test section for forcing unsteady flow in a linear compressor cascade using circular rods",
        "author": "Wade, Patrick C.",
        "year": "2003",
        "note": "Air Force Institute of Technology",
        "url": ""
      },
      {
        "title": "Validation and optimization of a MEMS propulsion concept: The free molecule micro -resistojet",
        "author": "Wong, Joyce T. S.",
        "year": "2003",
        "note": "Arizona State University",
        "url": ""
      },
      {
        "title": "A coupled rotor -fuselage vibration analysis for helicopter rotor system fault detection",
        "author": "Yang, Mao",
        "year": "2003",
        "note": "University of Maryland, College Park",
        "url": ""
      },
      {
        "title": "Adaptive limit margin detection and limit avoidance",
        "author": "Yavrucuk, Ilkay",
        "year": "2003",
        "note": "Georgia Institute of Technology",
        "url": ""
      },
      {
        "title": "Trace contaminant removal using adsorption and membrane methods",
        "author": "Ye, Xinhuai",
        "year": "2003",
        "note": "Vanderbilt University",
        "url": ""
      },
      {
        "title": "Deformation and breakup of round drops and nonturbulent liquid jets in uniform crossflows",
        "author": "Aalburg, Christian",
        "year": "2002",
        "note": "University of Michigan",
        "url": ""
      },
      {
        "title": "The effect of fuel injector geometry on the flow structure of a swirl-stabilized gas turbine burner",
        "author": "Anning, Grant Hugh Gary",
        "year": "2002",
        "note": "University of Cincinnati",
        "url": ""
      },
      {
        "title": "Edge delamination of fabric-reinforced composites subjected to various thermal cycles",
        "author": "Babu, Karri Satyaprakash",
        "year": "2002",
        "note": "The University of Texas at Arlington",
        "url": ""
      },
      {
        "title": "Wireless communication and signal processing for aging aircraft wiring",
        "author": "Bates, Derek Waldorf",
        "year": "2002",
        "note": "Utah State University",
        "url": ""
      },
      {
        "title": "On the use of plasma for shock wave mitigation",
        "author": "Bivolaru, Daniel",
        "year": "2002",
        "note": "Polytechnic University",
        "url": ""
      },
      {
        "title": "Comparison of a dynamic finite element model of LoTEC© (low temperature, low thermal energy carrier) with experimentaldata",
        "author": "Blackwood, James Michael",
        "year": "2002",
        "note": "The University of Alabama in Huntsville",
        "url": ""
      },
      {
        "title": "Ignition in laminar and turbulent nonpremixed counterflow",
        "author": "Blouch, John Dewey",
        "year": "2002",
        "note": "Princeton University",
        "url": ""
      },
      {
        "title": "The design of the communication and telemetry system used by the Ionospheric Measurement Nanosatellite-Formation (ION-F) mission",
        "author": "Chandrasekaran, Anuradha",
        "year": "2002",
        "note": "Utah State University",
        "url": ""
      },
      {
        "title": "The strength of polycrystalline silicon at the micro- and nano-scales with applications to MEMS",
        "author": "Chasiotis, Ioannis",
        "year": "2002",
        "note": "California Institute of Technology",
        "url": ""
      },
      {
        "title": "Optimal design of HTCC composite laminates using genetic algorithms",
        "author": "Chen, Paichou",
        "year": "2002",
        "note": "California State University, Long Beach",
        "url": ""
      },
      {
        "title": "The optimization of analytic camber line and thickness distributions as a solution to the inverse problem of two-dimensional aerodynamic shape design",
        "author": "Christensen, Jonathan Brent",
        "year": "2002",
        "note": "Utah State University",
        "url": ""
      },
      {
        "title": "The environmental impact of 4(5)-methylbenzotriazole from aircraft deicing operations",
        "author": "Cornell, Jeffrey Scott",
        "year": "2002",
        "note": "University of Colorado at Boulder",
        "url": ""
      },
      {
        "title": "A computer code to determine the generalized cycle analysis of hydrocarbon-fueled scramjet engines using chemical kinetic analysis",
        "author": "Custodio, Troy",
        "year": "2002",
        "note": "The Cooper Union for the Advancement of Science and Art",
        "url": ""
      },
      {
        "title": "Differences in risk perception between pilots and air traffic controllers",
        "author": "Davison, Jeannie",
        "year": "2002",
        "note": "San Jose State University",
        "url": ""
      },
      {
        "title": "Experimental study of plasma energization at magnetic neutral points",
        "author": "Deaconu, Stelu S.",
        "year": "2002",
        "note": "The University of Alabama in Huntsville",
        "url": ""
      },
      {
        "title": "Experimental investigation of the flow characteristics within a shallow wall cavity for both laminar and turbulent upstream boundary layers",
        "author": "Dewar, William Gary",
        "year": "2002",
        "note": "Boston University",
        "url": ""
      },
      {
        "title": "Electrokinetic microactuator arrays for active sublayer control of turbulent boundary layers",
        "author": "Diez-Garias, Francisco J.",
        "year": "2002",
        "note": "University of Michigan",
        "url": ""
      },
      {
        "title": "Autonomous longitude and eccentricity control of geostationary spacecraft",
        "author": "Emma, Brian Patrick",
        "year": "2002",
        "note": "San Jose State University",
        "url": ""
      },
      {
        "title": "A study of the possible use of hybrid rocket systems as targets in ballistic missile defense tests",
        "author": "Gray, William Morgan",
        "year": "2002",
        "note": "The University of Alabama in Huntsville",
        "url": ""
      },
      {
        "title": "Physical and environmental impact testing of glass-reinforced nylon",
        "author": "Healy, Rebecca Sue",
        "year": "2002",
        "note": "Utah State University",
        "url": ""
      },
      {
        "title": "Improved thermal management strategies for utilizing cryocoolers in satellite systems",
        "author": "Jensen, Scott Mentor",
        "year": "2002",
        "note": "Utah State University",
        "url": ""
      },
      {
        "title": "The use of moving map technology to prevent wire strikes in helicopter flight",
        "author": "Jones, Karen M.",
        "year": "2002",
        "note": "San Jose State University",
        "url": ""
      },
      {
        "title": "Validation and implementation of Goldstein\"s vortex theory of screw propellers",
        "author": "Kelly, Quinn J.",
        "year": "2002",
        "note": "Utah State University",
        "url": ""
      },
      {
        "title": "Robust maximum forced response in mistuned turbine engine bladed disks",
        "author": "Kenyon, James A.",
        "year": "2002",
        "note": "Carnegie Mellon University",
        "url": ""
      },
      {
        "title": "Design optimization of high -lift configurations using a viscous adjoint-based method",
        "author": "Kim, Sangho",
        "year": "2002",
        "note": "Stanford University",
        "url": ""
      },
      {
        "title": "The flame spread and extinction characteristics of cotton-fiberglass fabric",
        "author": "Kleinhenz, Julie Elise",
        "year": "2002",
        "note": "Case Western Reserve University",
        "url": ""
      },
      {
        "title": "System identification",
        "author": "Lacy, Seth LaRoe",
        "year": "2002",
        "note": "University of Michigan",
        "url": ""
      },
      {
        "title": "The investigation of hypervelocity gouging",
        "author": "Laird, David Joseph",
        "year": "2002",
        "note": "Air Force Institute of Technology",
        "url": ""
      },
      {
        "title": "Incident reporting process on the C-17 Aircraft Program utilizing the application of the process based management seven step methodology",
        "author": "Lovik, Brad Harlan",
        "year": "2002",
        "note": "California State University, Dominguez Hills",
        "url": ""
      },
      {
        "title": "Statistical modeling of hyperspectral data using Gauss-Markov random fields and its application to classification",
        "author": "Masalmah, Yahya Mahmoud",
        "year": "2002",
        "note": "University of Puerto Rico, Mayaguez (Puerto Rico)",
        "url": ""
      },
      {
        "title": "Optimal design of annular aerospike engine nozzle",
        "author": "Masuda, Rei",
        "year": "2002",
        "note": "California State University, Long Beach",
        "url": ""
      },
      {
        "title": "Structural design of reusable composite aeroshell for launch vehicles",
        "author": "Matsuoka, Atsushi",
        "year": "2002",
        "note": "California State University, Long Beach",
        "url": ""
      },
      {
        "title": "Damping of structural vibrations by vorticity production",
        "author": "Maung, Patrick Michael",
        "year": "2002",
        "note": "Boston University",
        "url": ""
      },
      {
        "title": "A finite element investigation of sustained service loads on an isogrid structure",
        "author": "McGuire, Michael Philip",
        "year": "2002",
        "note": "The University of Alabama in Huntsville",
        "url": ""
      },
      {
        "title": "Performance enhancements on a pulsed detonation rocket",
        "author": "Meyers, Jason Matthew",
        "year": "2002",
        "note": "The University of Texas at Arlington",
        "url": ""
      },
      {
        "title": "An experimental study of the aerodynamic shroud in axial ventilation fan systems",
        "author": "Neal, Douglas Richard",
        "year": "2002",
        "note": "Michigan State University",
        "url": ""
      },
      {
        "title": "Experimental investigation of an ejector scramjet RBCC at Mach 4.0 and 6.5 simulated flight conditions",
        "author": "Nelson, Karl William",
        "year": "2002",
        "note": "The University of Alabama in Huntsville",
        "url": ""
      },
      {
        "title": "Failure analyses of polymer matrix composite (PMC) honeycomb sandwich joint panels",
        "author": "Nguyen, Son Van",
        "year": "2002",
        "note": "California State University, Long Beach",
        "url": ""
      },
      {
        "title": "Modular design for the left hand side aft loadmaster station (C-17)",
        "author": "Nguyen, Thuc Xuan",
        "year": "2002",
        "note": "California State University, Dominguez Hills",
        "url": ""
      },
      {
        "title": "Ice shape modeling enhancement for two-dimensional incompressible local-flow Navier-Stokes",
        "author": "Ogretim, Egemen Ol",
        "year": "2002",
        "note": "West Virginia University",
        "url": ""
      },
      {
        "title": "Local/global effects and maximum amplification of blade forced response in mistuned turbomachinery disks",
        "author": "Rivas Guerra, Alejandro Javier",
        "year": "2002",
        "note": "Arizona State University",
        "url": ""
      },
      {
        "title": "Modeling, simulation, and control of cavity flow oscillations",
        "author": "Rowley, Clarence W.",
        "year": "2002",
        "note": "California Institute of Technology",
        "url": ""
      },
      {
        "title": "Analytic modeling and experimental validation of intumescent behavior of charring heatshield materials",
        "author": "Russell, Gerald Wayne",
        "year": "2002",
        "note": "The University of Alabama in Huntsville",
        "url": ""
      },
      {
        "title": "Dynamic analysis of a designed aircraft prototype",
        "author": "Sakamoto, Yasushi",
        "year": "2002",
        "note": "California State University, Long Beach",
        "url": ""
      },
      {
        "title": "Properties of spray formation by turbulent primary breakup",
        "author": "Sallam, Khaled Abd-Elmonem",
        "year": "2002",
        "note": "University of Michigan",
        "url": ""
      },
      {
        "title": "Practical testing of aircraft wiring and insulation faults",
        "author": "Schmidt, Mark B.",
        "year": "2002",
        "note": "Utah State University",
        "url": ""
      },
      {
        "title": "An integrated methodology to proactively evaluate physically stressful tasks in restrictive work environments",
        "author": "Shanks, Kimberly Michelle",
        "year": "2002",
        "note": "University of Louisville",
        "url": ""
      },
      {
        "title": "Experimental study of thermosiphon performance",
        "author": "Sivanagere, Sumeeth S.",
        "year": "2002",
        "note": "West Virginia University",
        "url": ""
      },
      {
        "title": "An experimental investigation of a non-axisymmetric supersonic cold-flow ejector",
        "author": "Smith, Nathanial Timothy",
        "year": "2002",
        "note": "The University of Alabama in Huntsville",
        "url": ""
      },
      {
        "title": "Effects of pin bending-elasticity on bearing failure of pin-loaded composite holes",
        "author": "Swaim, Kenneth Wayne, Jr.",
        "year": "2002",
        "note": "The University of Alabama in Huntsville",
        "url": ""
      },
      {
        "title": "Advanced interceptor autopilot design via sliding mode control",
        "author": "Toomey, Richard Franklin",
        "year": "2002",
        "note": "The University of Alabama in Huntsville",
        "url": ""
      },
      {
        "title": "Aerodynamics of low aspect ratio wings at low Reynolds numbers with applications to micro air vehicle design",
        "author": "Torres, Gabriel Eduardo",
        "year": "2002",
        "note": "University of Notre Dame",
        "url": ""
      },
      {
        "title": "Key elements for cost-effective satellite development",
        "author": "Tran, Minh Anh",
        "year": "2002",
        "note": "California State University, Long Beach",
        "url": ""
      },
      {
        "title": "Space mission profiles to a selected potentially hazardous asteroid",
        "author": "Urschel, Peter Holt",
        "year": "2002",
        "note": "California State University, Fresno",
        "url": ""
      },
      {
        "title": "Atomization of a small-diameter liquid jet by a high-speed gas stream",
        "author": "Varga, Christopher Michael",
        "year": "2002",
        "note": "University of California, San Diego",
        "url": ""
      },
      {
        "title": "Development of a rule -based software system for the fabrication of a contoured EB-PVD TBC on a PW4000 second -stage blade",
        "author": "Weir, William Charles Stuart",
        "year": "2002",
        "note": "Worcester Polytechnic Institute",
        "url": ""
      },
      {
        "title": "Aerodynamic sound generated by a wing of complex geometry",
        "author": "Wood, Trevor Howard",
        "year": "2002",
        "note": "Boston University",
        "url": ""
      },
      {
        "title": "Life prediction of short fiber composites",
        "author": "Zago, Alessandro",
        "year": "2002",
        "note": "Stanford University",
        "url": ""
      }
    ]
  },
  {
    "key": "udn",
    "name": "udn 電子書",
    "type": "電子書",
    "vendor": "https://reading.udn.com/udnlib/afats",
    "trial": false,
    "total": 0,
    "items": []
  },
  {
    "key": "emerald",
    "name": "Emerald",
    "type": "電子期刊",
    "vendor": "https://www.emerald.com/insight/",
    "trial": false,
    "total": 0,
    "items": []
  }
];
